import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        {/* 404 Animation */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600 animate-pulse">
            404
          </h1>
          <div className="flex items-center justify-center gap-2 mt-4">
            <Search className="w-8 h-8 text-gray-400 animate-bounce" />
            <p className="text-2xl text-gray-600 font-medium">Page Not Found</p>
          </div>
        </div>

        {/* Message */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
          <p className="text-gray-600 text-lg mb-6">
            Oops! The page you're looking for doesn't exist. It might have been moved, deleted, or the URL might be incorrect.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-purple-600 to-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg transition-all duration-200 transform hover:scale-105"
            >
              <Home className="w-5 h-5" />
              Go Home
            </Link>

            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center gap-2 bg-white text-gray-700 px-6 py-3 rounded-lg font-semibold border-2 border-gray-300 hover:border-purple-600 hover:text-purple-600 transition-all duration-200"
            >
              <ArrowLeft className="w-5 h-5" />
              Go Back
            </button>
          </div>
        </div>

        {/* Helpful Links */}
        <div className="bg-gradient-to-r from-purple-100 to-blue-100 rounded-xl p-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Need Help?</h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
            <Link
              to="/discover"
              className="text-purple-600 hover:text-purple-700 font-medium hover:underline"
            >
              Browse Jobs
            </Link>
            <Link
              to="/pricing"
              className="text-purple-600 hover:text-purple-700 font-medium hover:underline"
            >
              View Pricing
            </Link>
            <Link
              to="/jobseeker/settings"
              className="text-purple-600 hover:text-purple-700 font-medium hover:underline"
            >
              Account Settings
            </Link>
          </div>
        </div>

        {/* Error Code */}
        <p className="text-gray-400 text-sm mt-8">
          Error Code: 404 - Page Not Found
        </p>
      </div>
    </div>
  );
}
